import { RESULT_STATE } from "../modules/enums";
import { useEffect, useState } from "react";
import axios from "axios";

export function useFetch<T>(url: string) {
    const [state, setState] = useState(RESULT_STATE.LOADING);
    const [data, setData] = useState<T | null>(null);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        axios
            .get(url)
            .then((response) => {
                setData(response.data);
                setState(RESULT_STATE.SUCCESS);
            })
            .catch((error) => {
                setError(error);
                setState(RESULT_STATE.ERROR);
            });
    }, [url]);

    return { state, data, error };
}
